import { useEffect, useState } from 'react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { useCompanyContacts } from 'hooks/useCompanies';

const detailsStyle = {
  gap: 'padding_4',
};

const companyTypeStyle = {
  color: Colors.TextQuiet,
  paddingY: 'padding_2',
};

type CompanyDataProps = {
  uuid: string;
  company_types: string[];
  numActiveProjects?: number;
};

export const CompanyData = ({
  uuid,
  company_types,
  numActiveProjects,
}: CompanyDataProps) => {
  if (!uuid) {
    return null;
  }

  // todo: we can just add these details to the project/{slug}/companies endpoint instead of calling another api
  const { data: companyContacts } = useCompanyContacts(uuid);

  // You can store the company data you need here
  const [, setCompanyContactsData] = useState<any>(null);

  // Fetch the data when the uuid prop changes
  useEffect(() => {
    if (companyContacts) {
      setCompanyContactsData(companyContacts);
    }
  }, [companyContacts]);

  return (
    <FlexColumn>
      {!!company_types.length && (
        <FlexRow sx={companyTypeStyle}>
          <Text.Small>{company_types.join(', ')}</Text.Small>
        </FlexRow>
      )}
      <FlexRow sx={detailsStyle}>
        {!!companyContacts?.count && (
          <FlexRow.Left>
            <Text.Small>{companyContacts?.count} Contacts</Text.Small>
          </FlexRow.Left>
        )}
        <FlexRow.Right>
          <Text.Small>{numActiveProjects || 0} Active Projects</Text.Small>
        </FlexRow.Right>
      </FlexRow>
    </FlexColumn>
  );
};
